<template functional>
  <section>
    <p class="fs-s">
      &copy; {{ new Date().getFullYear() }} Sašo Marković. All rights reserved.
    </p>
  </section>
</template>

<script>
export default {
  name: "TheFooterSection"
};
</script>

<style lang="scss" scoped>
section {
  padding: 3rem;
}
</style>
